import React, { Component } from 'react'
import { connect } from 'react-redux'
import starIcon from '../../icons/star.svg';
import starIconFilled from '../../icons/star_filled.svg';
import ReactHtmlParser from 'react-html-parser'; 
import messageIcon from '../../icons/messagePending2.svg'
import { Redirect } from 'react-router-dom'

class ReviewSummary extends Component { 

  constructor(props) {
    super(props);
    this.state = {
    review:'',
    oneStar:false,
    twoStar:false,
    threeStar:false,
    fourStar:false,
    fiveStar:false,
    reviewScore:0,
    name:''
    }
    }

    componentDidMount(props){
      this.setState({
        oneStar:this.props.project.oneStar,
        twoStar:this.props.project.twoStar,
        threeStar:this.props.project.threeStar,
        fourStar:this.props.project.fourStar,
        fiveStar:this.props.project.fiveStar,
        name:this.props.project.name
      })
      if(this.props.showOnStart){
        this.showReview();
      }
    }

    onMessage(message, id){
      console.log(message, id);
      this.setState({message:message, id:id, redirect:true})
    }


  showReview = (e) => {
  
    if(document.getElementById('review'+this.props.project.id).style.display==='none' || document.getElementById('review'+this.props.project.id).style.display===''){
      document.getElementById('review'+this.props.project.id).style.display = "block";  
    }
    else{
      if(!this.props.showOnStart){
        document.getElementById('review'+this.props.project.id).style.display = "none"; 
      }
    }
  }

  render(){
    if(this.state.redirect){
      return <Redirect to={'/reviewMessage/' + this.state.id + '/' + this.state.message + '/null'} />
    }
    const { project, original, message, userId } = this.props;
    const oneStar = this.state.oneStar?starIconFilled:starIcon;
    const twoStar = this.state.twoStar?starIconFilled:starIcon;
    const threeStar = this.state.threeStar?starIconFilled:starIcon;
    const fourStar = this.state.fourStar?starIconFilled:starIcon;
    const fiveStar = this.state.fiveStar?starIconFilled:starIcon;

    return(
      <div className='reviewSummary'>
        {this.props.admin && <span> {this.state.name} </span>}
        {
        message && <div className='messageIcon2' style={{paddingLeft:'300px', marginBottom:'-40px'}}><img src={messageIcon} onClick={() => this.onMessage(message, userId)} className="favIcon" alt="message" width="40px" height="40px" viewBox="0 0 40 40"/></div>  
        }
        <h5 id={'reviewName'+project.id} onClick={this.showReview}>{original && original.name}</h5>
        <div id={'review'+project.id} style={{"display":"none"}}>
        <div className='reviewContainer'>
          <div style={{"width":"100%"}}/>
          <div className='reviewContainer'>
            <div><img src={oneStar} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
            <div><img src={twoStar} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
            <div><img src={threeStar} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
            <div><img src={fourStar} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
            <div><img src={fiveStar} className="favIcon" alt="star" width="20px" height="20px" viewBox="0 0 20 20"/></div>  
          </div>
          <div style={{"width":"100%"}}/>
        </div>
        <p></p>
        <div className="showReview" id='rev'>
          <div> { ReactHtmlParser (this.props.project.review) } </div>
        </div>
        </div>
      </div>
    )
  }

}


const mapStateToProps = (state) => {
  return {
    state
  }
}

export default connect(mapStateToProps)(ReviewSummary)